<!-- <div class="container mt-3 mb-5 d-none d-sm-block">
  <div class="d-flex justify-content-center .d-none .d-md-block .d-lg-none">
    <div class="mx-5">
      <div class="d-flex flex-column justify-content-center text-center">
        <i class="fab fa-expeditedssl mt-5 fa-8x ds-text-primary"></i>
        <h2 class="mt-3">{{ '@direction.pages.notAuthorized.pageNotAuthorizedTitle' | translate }}</h2>
        <small class="text-center my-2">{{ '@direction.pages.notAuthorized.pageNotAuthorizedMessage' | translate }}</small>
      </div>
      <div class="mt-4 text-center">
        <button (click)="goToLogin()" type="button" class="btn ds-btn-primary">
          {{ '@direction.pages.notAuthorized.takeMeLogin' | translate }}
        </button>
      </div>
    </div>
  </div>
</div> -->

<div class="content-wrapper">
  <div class="container-fluid">
    <div class="content-header">
      <div class="ds-center">
        <div class="d-flex flex-column justify-content-center text-center">
          <i class="fab fa-expeditedssl mt-5 fa-8x ds-text-primary"></i>
          <h2 class="mt-3">{{ '@direction.pages.notAuthorized.pageNotAuthorizedTitle' | translate }}</h2>
          <small class="text-center my-2">{{ '@direction.pages.notAuthorized.pageNotAuthorizedMessage' | translate }}</small>
        </div>
        <button type="button" class="btn btn-primary mt-4" (click)="goToLogin()">{{ '@direction.pages.notAuthorized.takeMeLogin' | translate
          }}</button>
      </div>
    </div>
  </div>
</div>


<!-- <div class="container mt-3 mb-5 d-block d-sm-none">
  <div class="d-flex justify-content-center flex-column">
    <div class="mx-auto mt-5">
      <i class="fab fa-expeditedssl fa-6x"></i>
    </div>
    <div class="mx-5 mb-5">
      <div class="d-flex flex-column justify-content-center text-center">
        <h2 class="mt-3">{{ '@direction.pages.notAuthorized.pageNotAuthorizedTitle' | translate }}</h2>
        <small class="text-center my-2">{{ '@direction.pages.notAuthorized.pageNotAuthorizedMessage' | translate }}</small>
      </div>
      <div class="mt-4 text-center">
        <button (click)="goToLogin()" type="button" class="btn ds-btn-primary">
          {{ '@direction.pages.notAuthorized.takeMeLogin' | translate }}
        </button>
      </div>
    </div>
  </div>
</div> -->